export const getIntialValues = (data = {}) => ({
  banner_image: data?.banner_image || "/assets/image/banner.jpg",
  logo: data?.logo || "/assets/svg/logo1.svg",
  title: {
    white: data?.title?.white || "Let's Discuss What You're",
    orange: data?.title?.orange || "Looking For",
  },
  description: data?.description || "Whether you're planning a home, setting up an industrial operation, or evaluating a long-term investment, our team can help you explore the right opportunity.",
  buttons: data?.buttons?.length
    ? data.buttons
    : [
        { label: "Schedule a Call", href: "#", variant: "filled" },
        { label: "Enquire Now", href: "#", variant: "outline" },
      ],
  explore_links: data?.explore_links?.length
    ? data.explore_links
    : [
        { label: "About", href: "/about-us" },
        { label: "Residents", href: "/residential" },
        { label: "Industry", href: "/industrial" },
        { label: "Blogs", href: "/blogs" },
        { label: "Contact Us", href: "/contact-us" },
      ],
  social_links: data?.social_links?.length
    ? data.social_links
    : [
        { label: "Instagram", href: "#" },
        { label: "Facebook", href: "#" },
        { label: "LinkedIn", href: "#" },
      ],
  contact_links: data?.contact_links?.length
    ? data.contact_links
    : [
        { label: "Tel: +91 0000000000", href: "tel:+910000000000" },
        { label: "Email: info@example.com", href: "mailto:info@example.com" },
        { label: "Address: Your Address Here", href: "#" },
      ],
  rera_details: {
    reg_no: data?.rera_details?.reg_no || "RERA-PKL-PWL-873-2026",
    date: data?.rera_details?.date || "24.03.2026",
    valid_upto: data?.rera_details?.valid_upto || "21.01.2031",
    qr_code: data?.rera_details?.qr_code || "/assets/image/industry/QR.png",
  },
  bottom_links: data?.bottom_links?.length
    ? data.bottom_links
    : [
        { label: "Privacy policy", href: "/privacy-policy" },
        { label: "Terms of service", href: "/terms-and-conditions" },
      ],
  copyright_text: data?.copyright_text || "© Copyright 2026 realestate. All Rights Reserved",
});

export const generatePayload = (values) => {
  const { _id, createdAt, updatedAt, __v, ...payload } = values;
  return payload;
};
